export default function FAQuestionTitle(props: any) {
  return (
    <div className="text-gray-800 text-2xl font-bold">{props.children}</div>
  );
}
